import React from 'react';
import { CTABand } from '../../components/CTABand';
export function DoSomeMartialArtsFinalCTA() {
  return <CTABand headline="Ready to Try Martial Arts at Storm?" copy="Start with a trial class — no experience, no gear, no pressure. Coaches will help you pick the right starting class for your age and goals. Call 517-220-0621 or fill out the form on this page." data-id="element-936" />;
}